import { IApplicationState } from '../../types/redux';

export const selectImages = (state: IApplicationState) => {
  const { images, layoutImages } = state.projectData.project;

  return { images, layoutImages };
};
